<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import {
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'NoticeList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'notices',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: {
          title: {
            label: this.$t('system.text_307'),
            filter: true,
            formatter: val => {
              return `title.contains("${val}")`
            },
          },
          content: {
            label: this.$t('system.text_308'),
            filter: true,
            formatter: val => {
              return `content.contains("${val}")`
            },
          },
        },
      }),
      exportDataOptions: {
        items: [
          { label: this.$t('system.text_307'), key: 'title' },
          { label: this.$t('system.text_308'), key: 'content' },
          { label: this.$t('system.text_127'), key: 'created_at' },
          { label: this.$t('system.text_309'), key: 'author' },
        ],
      },
      columns: [
        getCopyWithContentTableColumn({
          title: this.$t('system.text_307'),
          field: 'title',
        }),
        getCopyWithContentTableColumn({
          title: this.$t('system.text_308'),
          field: 'content',
        }),
        getTimeTableColumn({
          field: 'created_at',
          title: this.$t('system.text_127'),
        }),
        getCopyWithContentTableColumn({
          title: this.$t('system.text_309'),
          field: 'author',
        }),
        {
          title: this.$t('system.announcement.scope'),
          field: 'visible_scope',
          slots: {
            default: ({ row }) => {
              if (!row.visible_scope || row.visible_scope.toLowerCase() === 'system') {
                return [this.$t('common_723')]
              }

              const domain = row.project_domain || row.domain || row.domain_name || row.domain_id
              return [domain ? domain + ' ' + this.$t('dictionary.domain') : '-']
            },
          },
        },
      ],
      groupActions: [
        {
          label: this.$t('system.text_128'),
          permission: 'notices_create',
          action: () => {
            this.createDialog('NoticeCreateDialog', {
              success: () => {
                this.refresh()
              },
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
              validate: this.$store.getters.isAdminMode || this.$store.getters.isDomainMode,
            }
          },
        },
        {
          label: this.$t('system.text_129'),
          permission: 'notices_delete',
          action: () => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              name: this.$t('dictionary.notice'),
              data: this.list.selectedItems,
              columns: this.columns,
              title: this.$t('system.text_129'),
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              validate: this.list.selectedItems.length > 0 && this.list.selectedItems.every(item => this.$store.getters.isAdminMode || (this.$store.getters.isDomainMode && item.visible_scope === 'domain')),
            }
          },
        },
      ],
      singleActions: [
        {
          label: this.$t('system.text_152'),
          permission: 'notices_update',
          action: obj => {
            this.createDialog('NoticeUpdateDialog', {
              data: [obj],
              columns: this.columns,
              success: () => {
                this.refresh()
              },
            })
          },
          meta: (obj) => {
            if (this.$store.getters.isAdminMode) {
              return {
                validate: true,
              }
            }

            if (this.$store.getters.isDomainMode && obj.visible_scope === 'domain' && this.$store.getters.userInfo.projectDomain === obj.project_domain) {
              return {
                validate: true,
              }
            }

            return {
              validate: false,
              tooltip: this.$t('common_716'),
            }
          },
        },
        {
          label: this.$t('system.text_129'),
          permission: 'notices_delete',
          action: (obj) => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              name: this.$t('dictionary.notice'),
              data: [obj],
              columns: this.columns,
              title: this.$t('system.text_129'),
              onManager: this.onManager,
            })
          },
          meta: (obj) => {
            if (this.$store.getters.isProjectMode) {
              return {
                validate: false,
                tooltip: this.$t('common_716'),
              }
            }
            if (this.$store.getters.isDomainMode && (this.$store.getters.userInfo.projectDomain !== obj.project_domain || obj.visible_scope !== 'domain')) {
              return {
                validate: false,
                tooltip: this.$t('common_716'),
              }
            }

            return {
              validate: true,
            }
          },
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...this.getParams,
        scope: this.$store.getters.scope,
        details: true,
      }
      return ret
    },
  },
}
</script>
